<template>
  <button
    class="py-0 px-2 h-5.5 rounded-full text-darkGray bg-grayLighter flex items-center gap-2 cursor-default"
  >
    <TextV2 class="body-10 font-bold whitespace-nowrap">
      <slot />
    </TextV2>
  </button>
</template>
